import { Stack, Typography } from "@mui/material";
import { E2eTestSuiteResult } from "services/KnowfullyAdminClient";

type SuiteMiniStatsProps = {
  suite: E2eTestSuiteResult;
};

const SuiteMiniStats = ({ suite }: SuiteMiniStatsProps) => {
  const total = suite.cases?.length ?? 0;
  const failed = suite.cases?.filter((c) => c.status === "failed").length ?? 0;
  const flaky = suite.cases?.filter((c) => c.status === "flaky").length ?? 0;
  const skipped = suite.cases?.filter((c) => c.status === "skipped").length ?? 0;
  const passed = total - failed - flaky - skipped;

  if (total === 0) return null;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Typography variant="caption" color={failed > 0 ? "error" : "success.main"}>
        {passed}/{total - skipped} passed
      </Typography>
      {flaky > 0 && (
        <Typography variant="caption" color="warning.main">
          · {flaky} flaky
        </Typography>
      )}
      {skipped > 0 && (
        <Typography variant="caption" color="text.disabled">
          · {skipped} skipped
        </Typography>
      )}
    </Stack>
  );
};

export default SuiteMiniStats;
